<template>
  <div>
    <slotBase :bg-grey="true" :loading="isLoading">
      <template v-slot:title>
        <titleBar :header-title="'Pilih E-Pay'" @back="back" />
      </template>

      <template v-slot:content>
        <div
          v-if="
            dataGlobalCustomer.customer &&
            dataGlobalCustomer.customer.length > 0
          "
          class="main-content d-flex flex-column align-items-start p-x-20"
          style="gap: 16px"
        >
          <template v-if="listedEpay.length > 0">
            <div class="top-notify mt-4 align-items-start d-grid mx-2">
              <p class="my-0 f-Overpass f-w-600 f-16">
                {{ listedEpay.length }} E-Pay ditemukan
              </p>
              <p class="my-0 f-Overpass f-w-400 f-14 f-c-grey">
                Anda memiliki {{ listedEpay.length }} E-Pay yang terdaftar dengan nama
                berbeda untuk outlet ini. Pilih E-pay yang akan anda gunakan untuk
                membayar transaksi ini.
              </p>
            </div>
            <template v-for="(epay, index) in listedEpay">
              <cardEpay
                :namaCust="epay.nama"
                :saldo="epay.quota_emoney.saldo"
                :updated_at="epay.quota_emoney.updated_at"
                :idcustomer="epay.idcustomer"
                :idoutlet="epay.outlet.idoutlet"
                :namaoutlet="epay.outlet.nama"
                :key="index"
              />
            </template>
          </template>
          <template v-else>
            <div class="mx-auto" style="margin-top: 100%">
              <p class="text-center f-14 f-c-grey">
                Anda Tidak Memiliki Epayment Di Outlet Ini<br>Silahkan Top Up Epayment
              </p>
               <button
                type="button"
                class="btn btn-primary w-100 "
                @click="$router.push('/topUpPage')"
              >
                Top  Up Epayment
              </button>
            </div>
          </template>
        </div>
      </template>
    </slotBase>
  </div>
</template>

<script>
import slotBase from "@/components/slots/slotBase.vue";
import titleBar from "@/components/design/titleBar.vue";
import cardEpay from "../components/cardEpay.vue";
import VueJwtDecode from "vue-jwt-decode";
import { mapState, mapActions } from "vuex";

export default {
  name: "pilihEpay",
  components: {
    slotBase,
    titleBar,
    cardEpay,
  },
  data() {
    return {
      listedEpay: [],
      isLoading: true,
    };
  },
  computed: {
    ...mapState("scan", {
      dataGlobalCustomer: "dataGlobalCustomer",
      dataPesanan: "dataPesanan",
    }),
  },

  methods: {
    ...mapActions({
      getCustomerGlobal: "scan/getCustomerGlobal",
    }),

    back() {
      this.$router.replace({ name: "pilihLayanan" });
    },
  },

  mounted() {
    const tokenData = VueJwtDecode.decode(localStorage.getItem("token"));
    let tokenDataFix = tokenData.id_customer_global;
    this.isLoading = true;
    this.getCustomerGlobal(tokenDataFix).then(() => {
      this.dataGlobalCustomer.customer.forEach(customer => {
        if (
          customer.owner_idowner == this.$route.query.idowner &&
          customer.outlet !== null &&
          customer.quota_emoney !== null &&
          customer.quota_emoney.saldo !== 0) {
            if (customer.quota_emoney.jenis_emoney == 2) {
              this.listedEpay.push(customer)
            } else if (customer.quota_emoney.masa_aktif >= new Date().getTime()) {
              this.listedEpay.push(customer)
            }
        }
      })
    }).catch((e) => {
      this.$toast.error(e)
    }).finally(() => {
      this.isLoading = false;
    })
  },
};
</script>
